import Header from '../../components/Header/Header';
import { Outlet } from "react-router-dom";
import useAuth from '../../hooks/useAuth';

const AuthHome = () => {
  const { tokenCookies, removeTokenCookie } = useAuth(); 

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header tokenCookies={tokenCookies} removeTokenCookie={removeTokenCookie} />
      <main className="pt-16">
        <Outlet />
      </main>
    </div>
  );
};

export default AuthHome;